import { useEffect, useRef, useState } from 'react';

// Adds a "visible" flag once an element scrolls into view. Runs regardless of
// prefers-reduced-motion — the global stylesheet rule simply removes the
// transition, so content still becomes visible, just without the animation.
export const useScrollReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') { setVisible(true); return undefined; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { setVisible(true); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -70px 0px' });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, visible];
};
